import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Observable, distinctUntilChanged, map } from 'rxjs';

import { Schema, SchemaService } from '../../services/schema/schema.service';

@Component({
  selector: 'fin-schema',
  templateUrl: 'schema.component.html',
  host: { ngSkipHydration: 'true' },
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SchemaComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);
  private schemaService = inject(SchemaService);

  htmls$: Observable<SafeHtml[]>;

  ngOnInit(): void {
    this.htmls$ = this.schemaService.schemas$.pipe(
      distinctUntilChanged(),
      map((schemas: Schema[]) => schemas.map((schema) => this.getSafeHTML(schema)))
    );
  }

  private getSafeHTML(schema: Schema): SafeHtml {
    const json = schema ? JSON.stringify(schema, null, 2).replace(/<\/script>/g, '<\\/script>') : ''; // escape / to prevent script tag in JSON
    const html = `<script type="application/ld+json">${json}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
